module.exports = __webpack_public_path__ + "static/img/pic_1@2x.694c993.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/pic_1@2x.png
// module id = PKEY
// module chunks = 1